import type {FileViewForm} from 'shared/constants';
import type {OnlineFile} from 'src/features/media-viewer/lib/mv-types';

export function createMediaViewerOnlineFile(url: string, viewForm: FileViewForm): OnlineFile {
    return {
        id: -1,
        text: 'Online file',
        hasTextualForm: false,
        name: url,
        directory: null,
        viewForms: [viewForm],
        category: {
            id: -1,
            name: '',
            acceptableFileTypes: [],
            text: ''
        },
        accessType: {
            id: -1,
            text: ''
        },
        filename: url,
        size: -1,
        source: url,
        creatorId: -1,
        url,
        creationDate: new Date().toISOString(),
        online: true,
        sourceUrl: url,
        showPermission: {
            allowed: true
        },
        exportPermission: {
            allowed: true
        },
        printPermission: {
            allowed: true
        }
    }
}